import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import SectionHeading from 'pages/cart/section-heading';
import { UpsellItemButton } from 'pages/cart/upsell/styles';

export const UpsellCarouselWrapper = styled.div`
  margin: 0 0 1rem 1rem;
  ${SectionHeading} {
    font: ${brandFont.headerThree};
    margin: 1.5rem 0 0.5rem 0;
  }
  ${Styles.desktop`
    ${UpsellItemButton} {
      box-shadow: none;
    }
  `}
`;
